import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RoutesMap, TOP_BANNER_PADDING } from 'src/const';
// import { HomePage } from '../Pages';
import { MarketDashboard } from '../Dashboards/Market';
import { Login } from '../Pages/Login';
import { Register } from '../Pages/Register';
import { ProtectedRoute } from './ProtectedRoute';
import { EmailVerify } from '../Components';
import { IBAS } from '../Dashboards/Admin/Tools/IBAS';
import ActiveMarkets from '../Dashboards/Admin/Pages/ActiveMarkets';
import { ErrorPage, ResetPassword, ResetPasswordConfirmation } from '../Pages';
import CreateBigMarket from '../Dashboards/Admin/Tools/createBigMarkets';
import { BigMarkets, SingleBigMarkets } from '../Dashboards/Admin/Pages/BigMarkets';
import {AirbticsProBanner} from '../HOC/Banners/AirbticsProBanner';
import { useTheme } from '@material-ui/core';
import { useMediaQuery } from '@mui/material';
import { getBannerHeight } from 'src/utils/functions';
import Admin from '../Dashboards/Admin/Pages/Admin';
import AffiliatePartner from '../Dashboards/Admin/Pages/AffiliatePartner';
import DiscoveryAi from '../Pages/DiscoveryAi/DiscoveryAi';
import ApiCallsTracker from '../Dashboards/Admin/Pages/ApiCallsTracker';


const Routes = () => {
  const theme = useTheme();
  const isMobileBreakPointBanner = useMediaQuery(theme.breakpoints.down(630));
  const isTopBannerOpen = useSelector((state: any) => state.dashboard.isTopBannerOpen);  

  return (
    <>
      {isTopBannerOpen && <AirbticsProBanner />}
      <div style={{ marginTop: isTopBannerOpen ? getBannerHeight(isMobileBreakPointBanner) : 0 }}>
        <Switch>
          {/* page routes */}
          <Route exact path={RoutesMap.Home} component={MarketDashboard} />
          <Route path={RoutesMap.Pricing} component={MarketDashboard} />
          <Route path={RoutesMap.Login} component={Login} />
          <Route path={RoutesMap.Register} component={Register} />
          <Route exact path={RoutesMap.Data} component={MarketDashboard} />
          <Route path={RoutesMap.AirbnbPro} component={MarketDashboard} />
          <Route exact path={RoutesMap.Data + '/sample'} component={MarketDashboard} />
          {/* <Route path={'/granular-data/:country/:city/:district'} component={GranularDataDashboard} /> */}
          <Route path={'/historical/:country/:city/:district'} component={MarketDashboard} />
          <Route path={RoutesMap.Data + '/:country/:city/:district'} component={MarketDashboard} />
          <Route
            path={RoutesMap.Data + '/:coordinate/:searchedMarket'}
            component={MarketDashboard}
          />
          <Route path={'/:country/:city/:district/:source'} component={MarketDashboard} />
          <Route path={RoutesMap.SampleDashboard + '/:isSample'} component={MarketDashboard} />
          <Route path={RoutesMap.CompSet + '/:id'} component={MarketDashboard} />
          <Route path={RoutesMap.User + '/:settings'} component={MarketDashboard} />
          
          <Route path={RoutesMap.Calculator} component={MarketDashboard} />
          <Route path={RoutesMap.Discovery + "/:country"} component={MarketDashboard} />
          <Route path={RoutesMap.Discovery} component={MarketDashboard} />
          <Route path={RoutesMap.MyAnalysis} component={MarketDashboard} />           
          <ProtectedRoute exact path={RoutesMap.Partner + "/:partnerKey"} component={AffiliatePartner} />           
          <ProtectedRoute exact path={RoutesMap.Admin} component={Admin} />         
          <ProtectedRoute exact path={RoutesMap.ApiCallsTracker} component={ApiCallsTracker} />         
          <ProtectedRoute exact path={RoutesMap.IBAS} component={IBAS} />
          <ProtectedRoute exact path={RoutesMap.ActiveMarkets} component={ActiveMarkets} />
          <ProtectedRoute exact path={RoutesMap.CreateBigMarket} component={CreateBigMarket} />
          <ProtectedRoute exact path={RoutesMap.GetBigMarkets} component={BigMarkets} />          
          <ProtectedRoute
            exact
            path={RoutesMap.GetBigMarkets + '/:marketName'}
            component={SingleBigMarkets}
          />

          {/* Password Reset Route */}
          <Route exact path={RoutesMap.ResetPassword} component={ResetPassword} />
          <Route
            exact
            path={RoutesMap.ResetPassword + '/:resetLink'}
            component={ResetPasswordConfirmation}
          />

          {/* modal routes */}
          <Route path={RoutesMap.TailoredRegion + '/:isTailored'} component={MarketDashboard} />

          {/* utility routes */}
          <Route path={RoutesMap.VerifyEmail + '/:hashCode'} component={EmailVerify} />

          {/* fallback routes */}
          <Route path={RoutesMap.Error} component={ErrorPage} />
          <Redirect to={RoutesMap.Home} />
        </Switch>
      </div>
    </>
  );
};

export default Routes;
